export default __webpack_public_path__ + "static/media/logo.3ac17870.png";